import { InputBase, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import React, { useState } from "react";
import classes from "./styles.module.scss";
const SortAndSearch = (props) => {
  const [value, setValue] = useState("");
  const [sortValue, setSortValue] = useState("asc");

  return (
    <div
      className={`${classes.SortAndSearch} my-4 d-flex align-items-center justify-content-end`}
    >
      <InputBase
        value={value}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (props.search) {
              props.search(value);
            }
          }
        }}
        onChange={(e) => {
          if (e.target.value === "") {
            if (props.search) {
              props.search("");
            }
          }
          setValue(e.target.value);
        }}
        className="border-bottom mr-5"
        style={{ borderColor: "#c6c6c6" }}
        type="text"
        placeholder="Search"
      />
      <div className="d-flex align-items-center">
        <p
          className="mr-3 my-0"
          style={{ fontWeight: "700", fontSize: "16px" }}
        >
          Sort By
        </p>
        <FormControl size="small">
          <Select
            value={sortValue}
            variant="standard"
            onChange={(e) => {
              const newValue = e.target.value;
              setSortValue(newValue);
              let sort = {
                id: "price",
              };
              if (newValue === "desc") {
                sort = {
                  id: "price",
                  desc: "desc",
                };
              }
              if (props.applySort) {
                props.applySort(sort);
              }
            }}
            inputProps={{ "aria-label": "Price" }}
            sx={{ minWidth: 120 }}
          >
            <MenuItem value="asc">Low to High</MenuItem>
            <MenuItem value="desc">High to Low</MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default SortAndSearch;
